import {
  GET_DIMENSIONS_FAILED,
  GET_DIMENSIONS_SUCCESS,
  GET_DIMENSIONS_WATCHER,
  GET_DIVISIONS_FAILED,
  GET_DIVISIONS_SUCCESS,
  GET_DIVISIONS_WATCHER,
  GET_TEAMS_FAILED,
  GET_TEAMS_SUCCESS,
  GET_TEAMS_WATCHER,
  GRAPHIC_BARS_FAILED,
  GRAPHIC_BARS_SUCCESS,
  GRAPHIC_BARS_WATCHER,
  GET_HISTORY_BY_TEAM_WATCHER,
  GET_HISTORY_BY_TEAM_SUCCESS,
  GET_MEASURE_COLOR_RANGE_SUCCESS,
  GET_MEASURE_COLOR_RANGE_WATCHER,
  GET_QUESTIONS_WATCHER,
  GET_QUESTIONS_SUCCESS,
  GET_QUESTIONS_FAILED,
} from "./constants"

export function getQuestionsWatcher(payload) {
  return {
    type: GET_QUESTIONS_WATCHER,
    payload,
  }
}

export function getQuestionsSuccess(payload) {
  return {
    type: GET_QUESTIONS_SUCCESS,
    payload,
  }
}

export function getQuestionsFailed() {
  return { type: GET_QUESTIONS_FAILED }
}

export function graphicBarsWatcher(payload) {
  return {
    type: GRAPHIC_BARS_WATCHER,
    payload,
  }
}

export function graphicBarsSuccess(payload) {
  return {
    type: GRAPHIC_BARS_SUCCESS,
    payload,
  }
}

export function graphicBarsFailed() {
  return { type: GRAPHIC_BARS_FAILED }
}

export function getDivisionsWatcher(payload) {
  return {
    type: GET_DIVISIONS_WATCHER,
    payload,
  }
}

export function getDivisionsSuccess(payload) {
  return {
    type: GET_DIVISIONS_SUCCESS,
    payload,
  }
}

export function getDivisionsFailed() {
  return { type: GET_DIVISIONS_FAILED }
}

export function getDimensionsWatcher(payload) {
  return {
    type: GET_DIMENSIONS_WATCHER,
    payload,
  }
}

export function getDimensionsSuccess(payload) {
  return {
    type: GET_DIMENSIONS_SUCCESS,
    payload,
  }
}

export function getDimensionsFailed() {
  return { type: GET_DIMENSIONS_FAILED }
}

export function getTeamsWatcher(payload) {
  return {
    type: GET_TEAMS_WATCHER,
    payload,
  }
}

export function getTeamsSuccess(payload) {
  return {
    type: GET_TEAMS_SUCCESS,
    payload,
  }
}

export function getTeamsFailed() {
  return { type: GET_TEAMS_FAILED }
}

export function getHistoryByTeamWatcher(payload) {
  return {
    type: GET_HISTORY_BY_TEAM_WATCHER,
    payload,
  }
}

export function getHistoryByTeamSuccess(payload) {
  return {
    type: GET_HISTORY_BY_TEAM_SUCCESS,
    payload,
  }
}

export function getHistoryByTeamFailed(payload) {
  return { type: GET_HISTORY_BY_TEAM_SUCCESS }
}

/* MEASURE RANGE COLOR */
export function getMeasureColorRangeWatcher(payload) {
  return {
    type: GET_MEASURE_COLOR_RANGE_WATCHER,
    payload,
  }
}

export function getMeasureColorRangeSuccess(payload) {
  return {
    type: GET_MEASURE_COLOR_RANGE_SUCCESS,
    payload,
  }
}
